import React from 'react';

import { Category } from '../../api/api';

export const CategoryStateContext = React.createContext<Category | undefined>(undefined);

// TODO: gradually replace category prop with context.
export function useCategoryState() {
  const category = React.useContext(CategoryStateContext);
  if (category !== undefined) {
    return category;
  }
  throw 'CategoryStateContext used outside of provider';
}
